import { render, staticRenderFns } from "./SyEditor.vue?vue&type=template&id=104f7c58&scoped=true"
import script from "./SyEditor.vue?vue&type=script&lang=ts"
export * from "./SyEditor.vue?vue&type=script&lang=ts"
import style0 from "./SyEditor.vue?vue&type=style&index=0&id=104f7c58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f7c58",
  null
  
)

export default component.exports